module.exports = __webpack_public_path__ + "static/xceltoken (4)-d82c51022da35ce5cde9bc9cb5ed1ff2.png";